import { Promo } from "../price"
import { AType, summon } from "@silversea-ssc/functional-support"
import { Option } from "fp-ts/Option"

const _PromoOption = summon((F) =>
    F.interface(
        {
            type: F.stringLiteral("Promo"),
            promo: Promo(F),
            configurationCode: F.nullable(F.string()),
            //TODO add generic tokens?
        },
        "PromoOption",
    ),
)
export type PromoOption = AType<typeof _PromoOption>
export const PromoOption = Object.assign(_PromoOption, {
    make: (promo: Promo, configurationCode: Option<string>): PromoOption => ({
        type: "Promo",
        promo,
        configurationCode,
    }),
})
